import React from 'react'

type HeroProps = {
  onPrimaryClick?: () => void
  onSecondaryClick?: () => void
}

export default function Hero({ onPrimaryClick, onSecondaryClick }: HeroProps) {
  return (
    <section className="relative isolate overflow-hidden bg-neutral-950">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:flex lg:items-center lg:gap-x-16 lg:px-8 lg:py-28">
        <div className="mx-auto max-w-2xl lg:mx-0 lg:flex-auto">
          <p className="inline-flex items-center rounded-full bg-neutral-800 px-3 py-1 text-xs font-medium text-neutral-300 ring-1 ring-inset ring-neutral-700">
            Meal planning, not prep
          </p>
          <h1 className="mt-4 text-4xl font-semibold tracking-tight text-white sm:text-5xl">
            Meal Planning That Just Works.
          </h1>
          <p className="mt-4 text-lg leading-7 text-neutral-300">
            Plan your week in seconds. Eat better, save time, waste less. Nura turns
            "what's for dinner?" into a 5-minute ritual—smart weekly plans, auto shopping lists,
            and clean PDFs ready to go.
          </p>

          <ul className="mt-6 space-y-2 text-neutral-300">
            <li className="flex items-start gap-2">
              <span aria-hidden className="mt-1 h-1.5 w-1.5 rounded-full bg-white" />
              Weekly meal plans tailored to you
            </li>
            <li className="flex items-start gap-2">
              <span aria-hidden className="mt-1 h-1.5 w-1.5 rounded-full bg-white" />
              Auto-generated shopping lists
            </li>
            <li className="flex items-start gap-2">
              <span aria-hidden className="mt-1 h-1.5 w-1.5 rounded-full bg-white" />
              Clean, printable PDFs
            </li>
            <li className="flex items-start gap-2">
              <span aria-hidden className="mt-1 h-1.5 w-1.5 rounded-full bg-white" />
              Local AI for speed &amp; privacy
            </li>
          </ul>

          <div className="mt-8 flex items-center gap-3">
            <button
              onClick={onPrimaryClick}
              className="inline-flex items-center justify-center rounded-md bg-white px-5 py-3 text-sm font-semibold text-neutral-900 shadow-sm hover:bg-neutral-200 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
              Start for $20/month — Founding Member
            </button>
            <button
              onClick={onSecondaryClick}
              className="inline-flex items-center justify-center rounded-md px-5 py-3 text-sm font-semibold text-white ring-1 ring-inset ring-neutral-700 hover:bg-neutral-900/50"
            >
              See how it works
            </button>
          </div>

          <p className="mt-4 text-sm text-neutral-400">
            Price locked for life while we're in beta. Cancel anytime in two clicks.
          </p>
        </div>
        <div className="mt-12 hidden w-full max-w-xl flex-none lg:mt-0 lg:block">
          {/* Optional: hero visual / screenshot */}
          <div className="aspect-[4/3] w-full rounded-xl border border-neutral-800 bg-neutral-900/40" />
        </div>
      </div>
    </section>
  )
}